import React, { Component } from "react";
import Header from "./components/Header/Header";
import Section1 from "./components/Bodys/Section1";
import Section2 from "./components/Bodys/Section2";
import Section3 from "./components/Bodys/Section3";
import Section4 from "./components/Bodys/Section4";
import Section5 from "./components/Bodys/Section5";
import Section6 from "./components/Bodys/Section6";
import AppleYoutube from "./components/Bodys/AppleYoutube";
import Footer from "./components/Footer/Footer";
import { Routes, Route, BrowserRouter } from "react-router-dom";

class App extends Component {
  render() {
    return (
      <div>
        <Header />
        <Section1 />
        <Section2 />
        <Section3 />
        <Section4 />
        <Section5 />
        <Section6 />
        <AppleYoutube />
        <Footer />
      </div>
    );
  }
}

export default App;
